import React from 'react';
import get_bundle from '../../domain/get_bundle';
import Locale from '../../domain/Locale';
import Color from '../../domain/Color';
import SponsorDomain from '../../domain/Sponsor';
import Layout from '../../components/Layout';
import Sponsor from '../../components/Sponsor';
import MarkdownComponent from '../../components/MarkdownComponent';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  err: t.Obj,
  sponsor: t.maybe(SponsorDomain),
  themeBtnColor: t.maybe(Color),
  bgColor: t.maybe(Color),
  goPurchases: t.maybe(t.Func),
  goCatalog: t.maybe(t.Func),
  goProduct: t.maybe(t.Func),
  doAcceptCookies: t.Func,
  partners: t.maybe(t.Obj)
})
export default class ApproveOrderError extends React.Component {

  getBgColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.bg_color;
  }

  getColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.color;
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor sponsor={this.props.sponsor} locale={this.props.locale} options={options} />);
  }

  goCatalog = (evt) => {
    evt.preventDefault();
    this.props.goCatalog();
  }

  goProduct = (evt) => {
    evt.preventDefault();
    this.props.goProduct();
  }

  goPurchases = (evt) => {
    evt.preventDefault();
    this.props.goPurchases();
  }

  getLink() {
    const bundle = get_bundle(this.props.locale).approve_order_error;
    switch (this.props.err.name) {
      case 'product sold out':
      case 'out of time':
        // vai a vedere altri prodotti
        if (t.Func.is(this.props.goCatalog)) {
          return <a href='#' className='next' onClick={this.goCatalog}>{bundle.go_catalog}</a>;
        }
        break;
      case 'item sold':
      case 'max items reached':
        // torna al prodotto
        return <a href='#' className='next' onClick={this.goProduct}>{bundle.go_product}</a>;
      case 'pending payment':
        // vai ai pagamenti
        return <a href='#' className='next' onClick={this.goPurchases}>{bundle.go_purchases}</a>;
    }
  }

  render() {
    const { locale, err } = this.props;
    const bundle = get_bundle(locale).approve_order_error;
    const name = err.name;

    return (
      <Layout sponsor={this.getSponsor()} partners={this.props.partners} bgColor={this.getBgColor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <div id='approve_order_error'>
          <div className='box dark error title'>
            <h1 className='large-text-center'>{bundle.title}</h1>
          </div>
          <div className='box light'>
            <div className='alert warning'>
              <MarkdownComponent>
                {bundle[name]}
              </MarkdownComponent>
            </div>
            {this.getLink()}
          </div>
        </div>
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/ApproveOrderError.js
 **/